(function(){
  document.querySelectorAll('.td-faq__item').forEach(function(item){
    item.querySelector('.td-faq__question').addEventListener('click', function(){
      var isOpen = item.classList.contains('is-open');
      document.querySelectorAll('.td-faq__item').forEach(function(i){
        i.classList.remove('is-open');
        i.querySelector('.td-faq__question').setAttribute('aria-expanded','false');
      });
      if(!isOpen){ item.classList.add('is-open'); this.setAttribute('aria-expanded','true'); }
    });
  });

  document.querySelectorAll('.td-read-more-btn').forEach(function(btn){
    var block = btn.closest('.td-seo-block');
    var moreContent = block ? block.querySelector('.td-seo-text-more') : null;
    if(!moreContent) return;
    btn.addEventListener('click', function() {
      moreContent.classList.toggle('is-visible');
      btn.textContent = moreContent.classList.contains('is-visible') ? 'Ler menos' : 'Ler mais';
    });
  });
})();